import React from 'react';
import { PROFILES } from '../profiles/index';

export default function ChooseScreen({ onSelect }) {
  return (
    <div className="space-y-6">
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h2 className="text-lg font-semibold">What are you importing?</h2>
        <p className="text-sm text-gray-500 mt-1">
          Choose the Multiview interface type that matches your source data. The tool will guide you
          through preparing, validating, and downloading an import-ready file.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Object.entries(PROFILES).map(([key, profile]) => (
          <button
            key={key}
            onClick={() => onSelect(key)}
            className="text-left p-5 rounded-lg border-2 border-gray-200 bg-white hover:border-mv-500 hover:shadow-md transition-all group"
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center text-lg shrink-0 bg-gray-100 text-gray-500 group-hover:bg-mv-600 group-hover:text-white transition-colors">
                {profile.icon}
              </div>
              <div className="min-w-0">
                <h3 className="font-semibold text-sm">{profile.name}</h3>
                <p className="text-xs text-mv-600 font-mono mt-0.5">{profile.interfaceId}</p>
                <p className="text-xs text-gray-500 mt-2">{profile.description}</p>
                <p className="text-xs text-gray-400 mt-2 italic">Best for: {profile.bestFor}</p>
              </div>
            </div>
            <div className="mt-4 text-xs font-medium text-mv-600 group-hover:text-mv-700">
              Start guided setup →
            </div>
          </button>
        ))}
      </div>

      <div className="bg-mv-50 border border-mv-100 rounded-lg p-4 text-sm text-mv-800">
        <strong>How it works:</strong> Choose your import type → review source format requirements →
        upload your file → fix any validation issues → download and import into Multiview.
      </div>
    </div>
  );
}
